"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var Small = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 35 35", version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { fillRule: "nonzero", fill: "none" },
            react_1.default.createElement("circle", { fill: fill, cx: 17.5, cy: 17.5, r: 17.5 }),
            react_1.default.createElement("path", { d: "M17.216 16.666L19 14h-4.883c-.894 1.596-1.728 3.223-2.621 4.713l-.029-.034L8.965 14H4l4.776 7h5.46l2.98-4.334M25.079 18.057c.718.005 1.423.001 2.16.001 0 .546.07 1.157-.07 1.639-.118.246-.302.454-.529.517-1.089-.011-2.126.006-3.285 0-.262-.05-.521-.403-.575-.703v-3.803l.07-.41c.097-.213.297-.397.48-.476h3.156l.254.04c.33.162.472.54.508.958h3.733c-.003-.365-.057-.75-.178-1.058-.168-.395-.562-.688-.908-.744h-8.31s-1.237-.092-1.952.137c-.357.204-.603.679-.619 1.15l-.013 3.582c.043.502-.103 1.103.178 1.478.246.467.672.576 1.086.63h9.033c.343-.004.708.052.997-.132.386-.227.635-.7.697-1.216L31 17.288h-5.924l.003.77", fill: "#FFF" }))));
};
var Vg = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#d00000' : _a, rest = __rest(props, ["fill"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: Small, fill: fill, shift: -22 }, rest));
};
exports.default = Vg;
